import "./_Header.scss";

// assets
import logo from "../../assets/icons/logo.svg";

function Header() {
  return (
    <nav className="d-flex justify-content-center bg-white p-3 mb-3">
      <img src={logo} className="logo" alt="Putt & Play from Hollywood Bowl" />
    </nav>
  );
}

export default Header;
